import { useAppLocation } from '@crm/hooks/useAppLocation'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { useLocales } from '@shared/locales'
import { type TabsProps, Card, Tabs } from 'antd'
import { Outlet, useParams } from 'react-router-dom'

export const ClientInfoTabs = () => {
  const { t } = useLocales()
  const { id } = useParams()
  const { pathname } = useAppLocation()
  const navigate = useAppNavigate()

  const items: TabsProps['items'] = [
    { key: paths.clientsDetails.root(id), label: t('lead.contacts') },
    { key: paths.clientsDetails.leads(id), label: t('lead.leads') },
    { key: paths.clientsDetails.contracts(id), label: t('lead.contracts') },
    {
      key: paths.clientsDetails.opportunities(id),
      label: t('lead.opportunities')
    },
    { key: paths.clientsDetails.tasks(id), label: t('lead.tasks') },
    { key: paths.clientsDetails.logs(id), label: t('lead.activity') }
  ]

  const onChangeTab = (activeKey: string) => navigate(activeKey)

  return (
    <Card variant="borderless">
      <Tabs
        destroyOnHidden
        activeKey={pathname || items[0]?.key}
        onChange={onChangeTab}
        items={items}
      />
      <Outlet />
    </Card>
  )
}
